// If updating data -
// 1. download sheet as a JS object with right property names. Should match `rawData.js`
// 2. use `formatFinalData` from `utils/helper` and copy paste it here
export const data = [
  {
    qId: 0,
    text: "How are you feeling about Thanksgiving this year?",
    options: [
      {
        text: "Like the host with the absolute MOST",
        nextQId: 1,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        text: "Just tell me what to bring and I’m there",
        nextQId: 1,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        text: "I’ll be in the corner with the 1000-piece puzzle",
        nextQId: 1,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        text: "When is that again?",
        nextQId: 1,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
    ],
  },
  {
    qId: 1,
    text: "What type of cook are you?",
    options: [
      {
        text: "Charge up the Roomba",
        nextQId: 2,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        text: "I take direction well",
        nextQId: 2,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        text: "Mise en place is my mantra",
        nextQId: 2,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
    ],
  },
  {
    qId: 2,
    text: "Pick your fighter:",
    options: [
      {
        text: "Salt",
        nextQId: 3,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        text: "Fat",
        nextQId: 3,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        text: "Acid",
        nextQId: 3,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
      {
        text: "Heat",
        nextQId: 3,
        possibleResultsIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      },
    ],
  },
  {
    qId: 3,
    text: "Your ideal Thanksgiving meal is:",
    options: [
      {
        text: "Traditional: Change makes me anxious",
        nextQId: 4,
        possibleResultsIds: [1, 2, 3, 4, 5],
      },
      {
        text: "Experimental: No one ever eats the turkey anyway",
        nextQId: 11,
        possibleResultsIds: [12, 13, 14, 15],
      },
      {
        text: "Somewhere in-between: I like to riff on the classics",
        nextQId: 7,
        possibleResultsIds: [6, 7, 8, 9, 10, 11],
      },
    ],
  },
  {
    qId: 4,
    text: "You always go back for:",
    options: [
      {
        text: "More potatoes",
        nextQId: 5,
        possibleResultsIds: [1, 3],
      },
      {
        text: "A shot of tequila",
        nextQId: 6,
        possibleResultsIds: [2, 4, 5],
      },
      {
        text: "Nothing! I’m saving room for dessert",
        nextQId: 6,
        possibleResultsIds: [2, 4, 5],
      },
      {
        text: "All the greens (don’t @ me)",
        nextQId: 6,
        possibleResultsIds: [2, 4, 5],
      },
    ],
  },
  {
    qId: 5,
    text: "On Thanksgiving day you’re thinking:",
    options: [
      {
        text: "I want to spend as little time in the kitchen as possible so I can be with my family",
        nextQId: null,
        possibleResultsIds: [1],
      },
      {
        text: "I want to spend as much time in the kitchen as possible so I can avoid my family",
        nextQId: null,
        possibleResultsIds: [3],
      },
    ],
  },
  {
    qId: 6,
    text: "Choose your weapon:",
    options: [
      {
        text: "Salad spinner",
        nextQId: null,
        possibleResultsIds: [4],
      },
      {
        text: "Stovetop burner",
        nextQId: null,
        possibleResultsIds: [5],
      },
      {
        text: "Oven",
        nextQId: null,
        possibleResultsIds: [2],
      },
    ],
  },
  {
    qId: 7,
    text: "Choose your weapon:",
    options: [
      {
        text: "Salad spinner",
        nextQId: null,
        possibleResultsIds: [6],
      },
      {
        text: "Stovetop burner",
        nextQId: 8,
        possibleResultsIds: [7, 8],
      },
      {
        text: "Oven",
        nextQId: 9,
        possibleResultsIds: [9, 10, 11],
      },
    ],
  },
  {
    qId: 8,
    text: "To which does your heart belong?",
    options: [
      {
        text: "I <3 carbs",
        nextQId: null,
        possibleResultsIds: [7],
      },
      {
        text: "Betrothed to butter",
        nextQId: null,
        possibleResultsIds: [8],
      },
    ],
  },
  {
    qId: 9,
    text: "You always go back for:",
    options: [
      {
        text: "More potatoes",
        nextQId: null,
        possibleResultsIds: [9],
      },
      {
        text: "A shot of tequila",
        nextQId: 10,
        possibleResultsIds: [10, 11],
      },
      {
        text: "Nothing! I’m saving room for dessert",
        nextQId: 10,
        possibleResultsIds: [10, 11],
      },
      {
        text: "All the greens (don’t @ me)",
        nextQId: 10,
        possibleResultsIds: [10, 11],
      },
    ],
  },
  {
    qId: 10,
    text: "On Thanksgiving day you’re thinking:",
    options: [
      {
        text: "I want to spend as little time in the kitchen as possible so I can be with my family",
        nextQId: null,
        possibleResultsIds: [11],
      },
      {
        text: "I want to spend as much time in the kitchen as possible so I can avoid my family",
        nextQId: null,
        possibleResultsIds: [10],
      },
    ],
  },
  {
    qId: 11,
    text: "Are your people into spicy foods?",
    options: [
      {
        text: "Welp, not really",
        nextQId: null,
        possibleResultsIds: [12],
      },
      {
        text: "We were born to spice",
        nextQId: 12,
        possibleResultsIds: [13, 14, 15],
      },
    ],
  },
  {
    qId: 12,
    text: "You always go back for:",
    options: [
      {
        text: "More potatoes",
        nextQId: 13,
        possibleResultsIds: [13, 15],
      },
      {
        text: "A shot of tequila",
        nextQId: null,
        possibleResultsIds: [14],
      },
      {
        text: "Nothing! I’m saving room for dessert",
        nextQId: null,
        possibleResultsIds: [14],
      },
      {
        text: "All the greens (don’t @ me)",
        nextQId: null,
        possibleResultsIds: [14],
      },
    ],
  },
  {
    qId: 13,
    text: "On Thanksgiving day you’re thinking:",
    options: [
      {
        text: "I want to spend as little time in the kitchen as possible so I can be with my family",
        nextQId: null,
        possibleResultsIds: [15],
      },
      {
        text: "I want to spend as much time in the kitchen as possible so I can avoid my family",
        nextQId: null,
        possibleResultsIds: [13],
      },
    ],
  },
]
